



































































































































































































































import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getHourFromTimestamp,
    formattedDate,
    booleanFormatter,
    getUniqueId,
    getIndexFromList,
    itemsPerPageOptionsTable
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector
    }
})
export default class ModalForcePeriod extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default() {return []}}) vehiclesOptions: Array<object>;
    @Prop({default(){return []}}) selectedWorkSegments: Array<object>;
    @Prop({default(){return []}}) overlappedPeriods: Array<object>;
    @Prop({default: null}) forcedPeriodPatch: null | object;
    @Prop({default: null}) forcedPeriodToAdd: null | object;
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    forceSubmitBtn: string = 'Forzar período de trabajo';
    defaultSubmitBtn: string = 'Guardar';
    listOverlappedPeriodsText: string = 'Lista de períodos solapados';
    itemsPeriods: Array<object> = [];
    headersPeriods: Array<object> = [
        {
            text: 'Máquina',
            align: 'center',
            value: 'vehicle',
            class: 'pa-0'
        },
        {
            text: 'Fecha Inicio',
            align: 'center',
            value: 'start',
            width: '256px'
        },
        {
            text: 'Fecha Fin',
            align: 'center',
            value: 'end',
            width: '256px'
        },
        {
            text: '¿Es Trabajo?',
            align: 'center',
            value: 'is_work',
        }
    ]
    modalTitle: string = 'Forzar estado de trabajo';
    dateRangeSelected: any = [];
    discardSegment: boolean = false;
    isWork: boolean = false;
    calculateWithoutPerformance: boolean = false;
    ignoreAllFromTelemetry: boolean = false;
    discardPerformance: boolean = false;
    discardHumidity: boolean = false;
    ignoreAllFromCSV: boolean = false;
    discardPerformanceCSV: boolean = false;
    discardHumidityCSV: boolean = false;
    vehicleSelectedRV: boolean = false;
    forceOverlapped: boolean = false;
    canSubmit: boolean = false;
    errorMsg: string = '';
    // startDate: any = null;
    vehicleSelected: any = null;
    // endDate: any = null;
    endHour: string = '';
    defaultItem: object = {};
    StartDate: any = '';
    EndDate: any = '';
    StartHour: any = '';
    EndHour: any = '';
    editedIndex: number = -1;
    editedItem: object = {
        customId: '-1',
        start: '',
        end: '',
        is_work: false,
        hour_start: '',
        hour_end: '',
    };
    overlappedPeriodTitle: string = 'Períodos de trabajo solapados';
    overlappedPeriodAlert: string = 'Ya existe un período con estado de trabajo forzado para el mismo vehículo y fecha pero con estado contrario.';

    get existOverlappedPeriods(){
        return this.overlappedPeriods.length !== 0 ? true : false
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    updateHourEnd(value) {
        this.EndHour = value;
    }
    updateStartDate(value) {
        this.StartDate = value;
        this.updateEndDate(value);
    }
    updateEndDate(value) {
        this.EndDate = value;
    }
    updateHourStart(value) {
        this.StartHour = value;
    }

    boolFormatter(value){
        return booleanFormatter(value)
    }

    @Watch('selectedWorkSegments')
    observableSelectedWorkSegments(){
        this.assignItemsPeriods()
    }
    addNewPeriod(){
        let vehiclesInTable: Array<object> = [];
        let vehicleData: null | object = null;
        for (let index = 0; index < this.itemsPeriods.length; index++) {
            const segment = this.itemsPeriods[index];
            if(segment['vehicle'] !== null){
                let indexCurrentVehicleInVehiclesList = getIndexFromList(vehiclesInTable, 'id', segment['vehicle']['id']) 
                if(indexCurrentVehicleInVehiclesList == -1){
                    vehiclesInTable.push(segment['vehicle'])
                }
            }
        }

        if(vehiclesInTable.length == 1){
            vehicleData = vehiclesInTable[0]
        }
        
        this.itemsPeriods.unshift({
            customId: getUniqueId(),
            is_work: false,
            start: '',
            end: '',
            hour_start: '00:00',
            hour_end: '23:59',
            vehicle: vehicleData,
            pending: true
        });
        this.editItem(this.itemsPeriods[0]);
    }

    get disableAllButtons() {
        return this.discardSegment;
    }

    get isPatch() {
        return false;
    }

    get canSavePeriod() {
        if (
            this.StartDate == null ||
            this.StartDate === '',
            this.EndDate == null || 
            this.EndDate === '' ||
            this.vehicleSelected == null
        ) {
            return false;
        }
        return true;
    }

    close(item){
        setTimeout(() => {
            if (item['pending'] == true) {
                this.deleteItem(this.itemsPeriods[0]);
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
            this.resetValues();
        }, 300)
        
    }

    save(item) {
        if (this.editedIndex > -1) {
            let startDate = moment(this.StartDate, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let startHour = this.StartHour;
            this.editedItem['pending'] = false;
            let endDate = moment(this.EndDate, 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let endHour = this.EndHour;
            let vehicle: object | null = null;
            if(this.vehicleSelected !== null){
                let indexInVehiclesOptions = getIndexFromList(this.vehiclesOptions, 'id', this.vehicleSelected['id']);
                if(indexInVehiclesOptions !== -1){
                    vehicle = this.vehiclesOptions[indexInVehiclesOptions]
                }
            }
            this.editedItem['vehicle'] = vehicle;
            this.editedItem['is_work'] = this.isWork;
            this.editedItem['start'] = startDate + 'T' + startHour;
            this.editedItem['end'] = endDate + 'T' + endHour;
            Object.assign(this.itemsPeriods[this.editedIndex], this.editedItem);
            this.resetValues();
        }
    }

    resetValues() {
        this.canSubmit = true;
        this.editedIndex = -1;
        this.StartDate = '';
        this.EndDate = '';
        this.isWork = false;
        this.StartHour = '';
        this.EndHour = '';
        this.editedItem = {
            customId: '-1',
            start: '',
            is_work: false,
            end: '',
            hour_start: '',
            hour_end: '',
        }
        this.updateVehicleSelected(null)
    }

    editItem(item) {
        this.canSubmit = false;
        this.StartDate = item['start'];
        this.EndDate = item['end'];
        this.isWork = item['is_work'];
        if(item.vehicle !== null){
            this.updateVehicleSelected({
                id: item.vehicle.id,
                description: item.vehicle.description
            })
        }
        this.StartHour = item['start'] !== '' ? getHourFromTimestamp(item['start']) : '00:00';
        this.EndHour = item['end'] !== '' ? getHourFromTimestamp(item['end']) : '23:59';
        this.editedIndex = this.itemsPeriods.findIndex(it => it['customId'] === item['customId']);
        this.editedItem = Object.assign({}, item);
    }

    deleteItem(item) {
        const index = this.itemsPeriods.indexOf(item);
        if (index !== -1) {
            this.itemsPeriods.splice(index, 1);
        }
    }

    updateVehicleSelected(value) {
        this.vehicleSelected = value;
    }
    updateVehicleSelectedRV(value) {
        this.vehicleSelectedRV = value;
    }

    ignorePerformanceFromTelemetry(value) {
        this.uncheckIgnoreAllFromTelemetry();
        this.calculateWithoutPerformance = value;
    }

    clickDiscardSegment(value) {
        this.ignoreAllFromTelemetry = this.discardSegment;
        this.ignoreAllFromCSV = this.discardSegment;
        this.discardAllFromTelemetry(this.discardSegment);
        this.discardAllFromCSV(this.discardSegment);
    }

    discardAllFromTelemetry(value) {
        this.discardPerformance = value;
        this.discardHumidity = value;
        this.calculateWithoutPerformance = value;
    }

    discardAllFromCSV(value) {
        this.discardPerformanceCSV = value;
        this.discardHumidityCSV = value;
    }

    clickIgnoreAllFromTelemetry() {
        this.discardAllFromTelemetry(this.ignoreAllFromTelemetry);
    }

    clickIgnoreAllFromCSV() {
        this.discardAllFromCSV(this.ignoreAllFromCSV);
    }

    uncheckIgnoreAllFromTelemetry() {
        this.ignoreAllFromTelemetry = false;
    }

    uncheckIgnoreAllFromCSV() {
        this.ignoreAllFromCSV = false;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: 'Se han creado los periodos de trabajo'
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submit() {
        if(this.existOverlappedPeriods){
            this.forceOverlapped = true;
        }
        if(this.forcedPeriodPatch !== null){
            this.patchPeriod();
        }else{
            this.postPeriod();
        }   
        
    }

    patchPeriod() {
        let periodData = this.forcedPeriodPatch;
        if(periodData){
            periodData['force_overlapped'] = true;
            this.showLoadingDialog('Modificando...');
            InsuranceServices.patchIgnoreSegmentSowing(periodData['segment_id'], periodData)
            .then(res => {
                this.getRanchDetail();
                this.$_successLoadingDialog({
                    response: res,
                    alternative_msg: 'Período actualizado con éxito'
                });
                this.closeModal();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
        }
    }

    postPeriod() {
        // console.log("segmentos post", this.itemsPeriods);
        this.showLoadingDialog('Guardando períodos...');
        let newPeriod = this.forcedPeriodToAdd !== null ? this.forcedPeriodToAdd : this.getData;
        InsuranceServices.postIgnoreSegmentSowing(newPeriod)
            .then(res => {
                this.showSuccessLoadingDialog(res);
                this.$emit('add-new-error-lapses', res['forced_work_lapsse']);
                this.getRanchDetail();
            })
            .catch(err => {
                if(err && err.response && err.response.data && err.response.data.overlapped_periods){
                   this.addNewPeriodOverlapped(
                        err.response.data.overlapped_periods,
                        newPeriod
                    );
                }else{
                    this.showCatchLoadingDialog(err, 'Ocurrio un error');
                }
            });
    }


    get getData() {
        let periodsList:Array<object> = [];
        if(this.itemsPeriods.length > 0){
            periodsList = this.itemsPeriods.map(function(period){
                return {
                    vehicle: period['vehicle']['id'],
                    is_work: period['is_work'],
                    start_date: period['start'],
                    end_date: period['end']
                }
            })
        }
        return {
            periods: periodsList,
            force_overlapped: this.forceOverlapped
        }
    }

    get formIsValid() {
        this.setErrorForm('');

        if(this.itemsPeriods.length == 0 ){
            this.setErrorForm('Debe agregar al menos 1 segmento');
            return false
        }
        if(!this.canSubmit){
            this.setErrorForm('Tiene un período para guardar');
            return false
            

        }
        return true;
    }

    getFullTimestamp(date, hour) {
        return date + 'T' + hour;
    }

    assignItemsPeriods(){
        let items = this.overlappedPeriods.length !== 0 ? this.overlappedPeriods : this.selectedWorkSegments;
        let self = this;
        if(items.length > 0){
            items = items.map(function(item){
                let isWorkValue = self.existOverlappedPeriods ? item['is_work'] : false;
                if(self.existOverlappedPeriods){
                    item['start'] = item['start_date'];
                    item['end'] = item['end_date'];
                }
                return {
                    ...item,
                    pending: false,
                    is_work: isWorkValue
                }
            })
        }
        // console.log("assignItemsPeriods", items);
        this.itemsPeriods = JSON.parse(JSON.stringify(items))
    }

    enableActionsToHeaders(){
        if(!this.existOverlappedPeriods){
            this.headersPeriods.push({
                text: 'Acciones',
                align: 'center',
                value: 'actions',
                width: '80px'
            })
        }
    }

    @Emit()
    closeModal() {}

    @Emit()
    getRanchDetail() {}

    @Emit()
    addNewPeriodOverlapped(overlappedPeriods: Array<object>, newPeriod) {}

    doNothing(){}

    mounted() {
        this.$nextTick(() => {
            this.assignItemsPeriods();
            this.enableActionsToHeaders();
            if(this.itemsPeriods.length > 0){
                this.canSubmit = true;
            }
        });
    }
}
